import React from 'react';
import { Row } from 'reactstrap';
import { Colxx } from '../CustomBootstrap';

export const FeatureNotAvailable = () => {
  return (
    <Colxx xxs='12' xl={'12'}>
      <Row>
        <Colxx xxs='12' className='mb-4 mt-5'>
          <div
            className='d-flex align-items-center justify-content-center'
            style={{ flexDirection: 'row' }}
          >
            <span style={{ fontSize: 20 }}>
              This feature is only for{' '}
              <span
                className='actionLabelText'
                style={{ textDecoration: 'underline' }}
              >
                <a
                  href={'https://commonthreads.com/products/membership'}
                  target='_parent'
                  color='primary'
                  style={{
                    fontWeight: 500,
                  }}
                >
                  members
                </a>
              </span>
            </span>
          </div>
        </Colxx>
      </Row>
    </Colxx>
  );
};
